import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { createBusinessAccount } from './utils';

export default function* listenCreateBusinessAccount() {
  yield takeEvery(payoutActions.createStripeAccount.toString(), createBusinessAccount);
}
